<template>
    <el-dialog
        title="Add"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
    >
        <el-form
            label-position="top"
            label-width="80px"
            ref="form"
            :model="form"
        >
            <el-form-item label="渠道名称:">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="loading" @click="onSubmit"
                    >立即创建</el-button
                >
                <el-button @click="handleClose">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from "../../../server/index";
export default {
    props: ["dialogVisible"],
    data() {
        return {
            form: {
                name: "",
            },
            loading: false,
        };
    },
    methods: {
        onSubmit() {
            this.loading = true;
            const params = {
                name: this.form.name,
            };
            serverApi
                .channelAdd(params)
                .then((res) => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: "Add success",
                            type: "success",
                        });
                        this.$emit("closeModal", true);
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: "error",
                        });
                    }
                })
                .catch((e) => {
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: "error",
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleClose() {
            this.$emit("closeModal", false);
        },
    },
};
</script>

<style>
</style>